import { mandatePresenceStatuses } from "@/constants/mandate.js";
import contactModel from "@/store/orm-axios/models/Contact";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  upsertInStore(data, model, dataType) {
    let self = this;
    try {
      if (
        dataType == "Meeting" ||
        dataType == "MeetingResolution" ||
        dataType == "Mandate" ||
        dataType == "ResolutionVote" ||
        dataType == "Contact"
      ) {
        if (dataType == "Mandate") {
          // HACK: prevent meeting register process if mandate that has to be changed is already selected
          const previousData = model.find(data.id);
          if (previousData && previousData.is_selected) {
            const allModels = model.all();
            allModels.forEach(modelObj => {
              const mandateModel = model.find(modelObj.id);
              model.update({
                where: mandateModel.id,
                data(item) {
                  item.is_selected = false;
                },
              });
            });
            Swal.fire({
              icon: "warning",
              title: "Avertissement",
              text: "Cette personne a déjà été ajoutée !",
              timer: 3000,
              showConfirmButton: true,
            });
          }
          if (data.representant_contact_id) {
            let contactObject = contactModel.find(data.representant_contact_id);
            if (contactObject && contactObject.is_selected) {
              contactModel.update({
                where: contactObject.id,
                data(item) {
                  item.is_selected = false;
                },
              });
              const allModels = model.all();
              allModels.forEach(modelObj => {
                const mandateModel = model.find(modelObj.id);
                model.update({
                  where: mandateModel.id,
                  data(item) {
                    item.is_selected = false;
                  },
                });
              });
              Swal.fire({
                icon: "warning",
                title: "Avertissement",
                text: "Cette personne a déjà été ajoutée !",
                timer: 3000,
                showConfirmButton: true,
              });
            }
          }
        }

        this.conditionallyUpdateData(data, model);

        if (dataType == "Mandate") {
          // HACK: used another way to take care of video presence, through vuex modules
          this.updateMandateLastSeen(data, model);
        }

        return;
      }

      model.insertOrUpdate({
        data: data,
      });
    } catch (err) {
      console.error(err);
    }
  },
  deleteFromStore(dataId, model) {
    model.delete(dataId);
  },

  // helpers
  // !!!: similar functions are used in BO app too.. make changes there also if you change something here
  conditionallyUpdateData(data, model) {
    const fieldsToCompare = Object.keys(data);
    const previousData = model.find(data.id);

    if (previousData) {
      if (this.dataDiffersFromPrevious(data, previousData, fieldsToCompare)) {
        model.update({
          where: data.id,
          data: data,
        });
      }
    } else {
      model.insert({ data });
    }
  },
  dataDiffersFromPrevious(data, previousData, fields) {
    for (const field of fields) {
      if (typeof previousData[field] != "undefined") {
        let newValue = data[field];
        let oldValue = previousData[field];
        if (typeof newValue == "object") {
          newValue = JSON.stringify(newValue);
          oldValue = JSON.stringify(oldValue);
        }

        if (newValue != oldValue && !this.ignoreFieldComparison(field)) {
          return true;
        }
      }
    }
    return false;
  },
  ignoreFieldComparison(field) {
    const generalIgnoredFields = ["@context", "@type", "@id", "created", "updated", "deleted"];
    const mandateIgnoredFields = ["last_seen"];
    return generalIgnoredFields.concat(mandateIgnoredFields).includes(field);
  },

  // HACK: used another way to take care of video presence, not through vuex orm.. saved video presence needed info in an object in mandates modules and used that to check last seen on mandates
  updateMandateLastSeen(data, model) {
    if (
      data.presence_status == mandatePresenceStatuses.video ||
      data.presence_status == mandatePresenceStatuses.pouvoir_by_video
    ) {
      const previousData = model.getters("getMandateLastSeen")(data.id);
      if (previousData) {
        if (data.last_seen != previousData.last_seen) {
          model.store().commit("entities/mandates/upsertMandateLastSeen", data);
        }
      } else {
        model.store().commit("entities/mandates/upsertMandateLastSeen", data);
      }
    }
  },
};
